import React from 'react';
import PropTypes from 'prop-types';
import { trackClick } from '../../../service/relatedSearchTerms';
import './index.scss';

const SearchTags = ({ relatedTerms }) => (
    <div className="search-tags">
        {relatedTerms.map((term) => (
            <a key={term.pos} href={term.termUrl} onClick={trackClick}>{term.query}</a>
        ))}
    </div>
);

SearchTags.propTypes = {
    relatedTerms: PropTypes.array
};

SearchTags.defaultProps = {
    relatedTerms: []
};

export default SearchTags;
